import { formatDate } from '@angular/common';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Component, ElementRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { TerminoCondiciones } from 'src/app/models/mandatos-express/condiciones';
import { TerminoCondicionesFinal } from 'src/app/models/mandatos-express/condicionesFinal';
import { TerminoCondicionesRespuesta } from 'src/app/models/mandatos-express/condicionesRespuesta';
import { Estilos } from 'src/app/services/estilos/estilos';
import { DialogBaseComponent } from '../dialog-base/dialog-base.component';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Origin': '*'
  })
};

export interface DialogData {
  terminoCondiciones: TerminoCondiciones;
  terminoCondicionesFinal : TerminoCondicionesFinal;
  isEmbebido: boolean;
}

@Component({
  selector: 'lib-condiciones-generales-susComercio',
  templateUrl: './condiciones-generales-susComercio.component.html',
  styleUrls: ['./condiciones-generales-susComercio.component.css']
})
export class CondicionesGeneralesSusComercioComponent {

  contenidoParam : TerminoCondiciones;
  contenidoParamFinal : TerminoCondicionesFinal;
  private apiUrl = "/apiMandatosMT/condicionesGenerales";
  private apiUrlFinal = "/apiMandatosMT/condicionesGeneralesFinal";

  private apiUrlPdf = "/apiMandatosMT/condicionesGenerales/pdf";
  private apiUrlPdfFinal ="/apiMandatosMT/condicionesGeneralesFinal/pdf"

  private apiUrlSusComercio = "/apiMandatosMT/condicionesGeneralesSusComercio";
  private apiUrlFinalSusComercio = "/apiMandatosMT/condicionesGeneralesFinalSusComercio";
  private apiUrlPdfFinalSusComercio ="/apiMandatosMT/condicionesGeneralesFinalSusComercio/pdf"

  html : string = "";
  idMandato : string = '0';
  isDataAvailable: boolean = false;
  isEmbebido: boolean = false;

  estilos : Estilos = new Estilos();

  constructor(
    public dialogRef: MatDialogRef<CondicionesGeneralesSusComercioComponent>,
    private http: HttpClient,
    public dialog: MatDialog,
    private elementRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
      this.estilos.cambioEstilosSusComercio(elementRef);
      this.contenidoParam = data.terminoCondiciones;
      this.contenidoParamFinal = data.terminoCondicionesFinal;
      this.isEmbebido = data.isEmbebido;
    }

  ngOnInit(): void {
    let data: any;
    let api : string;
    if(this.contenidoParamFinal.idMandato != ''){
      this.idMandato = this.contenidoParamFinal.idMandato;
      api = this.isEmbebido ? this.apiUrlFinal : this.apiUrlFinalSusComercio;
      data = this.contenidoParamFinal;
    }else{
      api = this.isEmbebido ? this.apiUrl : this.apiUrlSusComercio;
      data = this.contenidoParam;
    }

    this.postGetTerminos(data, api).subscribe(data => {
        if(data.codResp = '0') {
          this.isDataAvailable = true;
          this.html = data.html;
        } else {
          this.onNoClick(false);
          this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
        }
    }, err => {
      console.error('error: ', err);
      this.onNoClick(false);
      this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
    });

  }

  postGetTerminos(body: any, api : string): Observable<TerminoCondicionesRespuesta> {
    return this.http.post<TerminoCondicionesRespuesta>(api, body, httpOptions);
  }

  downloadReportService(filtro: any,api : string): Observable<HttpEvent<Blob>> {
      return this.http.request(new HttpRequest(
        'POST',api , filtro,
        {
          reportProgress: true,
          responseType: 'blob'
        }));
  }

  public postDownloadReportFile(filtro: any) {
    let apiUrl = this.apiUrlPdf;
    if (this.idMandato != '0') {
      apiUrl = this.isEmbebido ? this.apiUrlPdfFinal : this.apiUrlPdfFinalSusComercio;
    }
    this.downloadReportService(filtro, apiUrl).subscribe(data => {
      if (data.type == HttpEventType.Response) {
        let downloadedFile: Blob;
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        downloadedFile = new Blob([data.body], { type: 'application/pdf;charset=utf-8' });
        a.download = 'Termino_Condiciones_' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
        a.href = URL.createObjectURL(downloadedFile);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      }
    },
      err => {
        console.error('error: ', err);
      }
    );
  }

    onNoClick(valor): void {
      this.dialogRef.close(valor);
    }

    descargarPDF()
    {
      if(this.contenidoParamFinal.idMandato != '')
        {
          this.postDownloadReportFile(this.contenidoParamFinal);
        }else
        {
          this.postDownloadReportFile(this.contenidoParam);
        }
    }

    showDialog(pTitle: string, pContent: string, pShowBtnCancel: boolean, pBtnCancelar: string, pBtnAceptar: string) {
      const dialogRef = this.dialog.open(DialogBaseComponent, {
        data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel, btnCancelar: pBtnCancelar, btnAceptar: pBtnAceptar},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {}
      });
    }
}